import { Dialog, DialogProps, useMediaQuery, useTheme } from '@mui/material';
import { styled } from '@mui/styles';
import { PmiDialogTitle } from '../dialog/title';
import { PmiButton } from 'shell/components/shared/button';
import { PmiDialogContent } from '../dialog/content';
import ViewerPDF from './pdf-viewer';
import { memo } from 'react';
import printJS from 'print-js';

export const PmiDialog = styled((props: DialogProps) => <Dialog {...props} />)(
  ({ fullScreen }) => ({
    '& .MuiDialog-paper': {
      minWidth: fullScreen ? '' : '25rem',
      maxWidth: 'none !important',
    },
  })
);

interface ModalViewerPDFProps {
  open: boolean;
  onClose: (open: boolean) => void;
  amountCertifate?: string;
  title?: string;
  data: string;
  name: string;
  downloadable?: boolean;
  printable?: boolean;
  isFullScreen?: boolean;
  customClose?: string;
  customPrint?: string;
  customOtherButton?: string;
  onClickOtherButton?: () => void;
}

const ModalViewerPDFComponent = ({
  open,
  onClose,
  title,
  data,
  name,
  downloadable = true,
  printable = true,
  isFullScreen,
  customClose = 'Chiudi',
  customPrint = 'Stampa',
  customOtherButton = '', // utilizzato per aggiungere un bottone dalle props
  onClickOtherButton,
}: ModalViewerPDFProps): React.ReactElement => {
  const theme = useTheme();

  const fullScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));

  return (
    <PmiDialog
      open={open}
      disablePortal
      fullScreen={isFullScreen ? isFullScreen : fullScreen}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <PmiDialogTitle id="alert-dialog-title" backgroundColor="cdmBrandSecondary" color="white">
        {title}
      </PmiDialogTitle>
      <PmiDialogContent>
        {!data ? undefined : (
          <ViewerPDF data={data} name={name} downloadable={downloadable} printable={printable} />
        )}
      </PmiDialogContent>
      <div className="pmi-d-flex pmi-justify-content-end pmi-pb-3 pmi-px-3">
        <div className="pmi-w-35">
          <PmiButton
            fullWidth
            onClick={() => {
              printJS({
                printable: data,
                type: 'pdf',
                base64: true,
              });
              return;
            }}
            color="primary"
            variant="contained"
            disabled={!printable}
          >
            {customPrint}
          </PmiButton>
        </div>
        <div className="pmi-w-35 pmi-pl-2">
          <PmiButton
            fullWidth
            onClick={() => {
              onClose(false);
            }}
            color="cdmBrand"
            variant="outlined"
          >
            {customClose}
          </PmiButton>
        </div>
        {Boolean(customOtherButton) ? (
          <div className="pmi-w-35 pmi-pl-2">
            <PmiButton
              fullWidth
              onClick={() => {
                if (onClickOtherButton) {
                  onClickOtherButton();
                }
              }}
              color="primary"
              variant="contained"
            >
              {customOtherButton}
            </PmiButton>
          </div>
        ) : undefined}
      </div>
    </PmiDialog>
  );
};

ModalViewerPDFComponent.displayName = 'Modal viewer pdf';

export const ModalViewerPDF = memo(ModalViewerPDFComponent) as typeof ModalViewerPDFComponent;
